import React from "react";

const VALUES = [
  {
    num: "01",
    title: "Integrity",
    img: "/images/integrity.jpg",
    text:
      "Rather than working on buildings like the masons of old, today's Freemasons focus on building themselves as people of integrity — and membership provides the structure to help achieve it.",
  },
  {
    num: "02",
    title: "Friendship",
    img: "/images/friendship.jpg",
    text:
      "One of the oldest social organisations in the world. Open to people from all religions and political persuasions, providing the common foundation for friendships that often last a lifetime.",
  },
  {
    num: "03",
    title: "Respect",
    img: "/images/respect.jpg",
    text:
      "With more than 150,000 members across the UK, Freemasonry brings people together irrespective of race, religion or any other perceived differences that can divide us as a society.",
  },
  {
    num: "04",
    title: "Service",
    img: "/images/service.jpg",
    text:
      "Whether participating in events, fundraising for charity or volunteering for community organisations — service is at the very heart of Freemasonry and at the heart of this Lodge.",
  },
];

function Values() {
  return (
    <section id="values" className="section section--paper2">
      <div className="container">
        <div style={{ maxWidth: "70ch" }}>
          <p className="eyebrow">What we stand for</p>
          <h2>Four values, shared with the Service we honour.</h2>
          <p className="lede">
            Our masonic values — Respect, Integrity, Service and Friendship — sit
            alongside those of the British Royal Air Force: Respect, Integrity, Service,
            Excellence.
          </p>
        </div>
        <div className="values">
          {VALUES.map((v) => (
            <article className="value-card" key={v.num}>
              <div className="value-card__img">
                <img src={v.img} alt="" loading="lazy" />
              </div>
              <div className="value-card__body">
                <p className="value-card__num">№ {v.num}</p>
                <h3 className="value-card__title">{v.title}</h3>
                <p className="value-card__text">{v.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Values;
